import React from "react"

class StayTypeDataType extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    if (this.props.row.reseration_segment) {
      if (this.props.row.reseration_segment.status == 'checked_in') {
        var stayType = <div>{I18n.t('check_in')}</div>
      } else if (this.props.row.reseration_segment.status == 'checked_out') {
        var stayType = <div>{I18n.t('check_out')}</div>
      } else if (this.props.row.reseration_segment.status == 'canceled' || this.props.row.reseration_segment.status == "no_show"){
        var stayType = <div>{I18n.t('vacant')}</div>
      } else {
        var stayType = <div>{I18n.t('stay_over')}</div>
      }
    } else {
      var stayType = <div>{I18n.t('vacant')}</div>
    }
    return stayType
  };

};

export default StayTypeDataType